export default __webpack_public_path__ + "static/puck-90910f6c70b76e716d71200ebef46c4b.png";